module.exports = __webpack_public_path__ + "img/success.714840ff.png";